module.exports = {"id":"210868","name":"José Mari","rating":"72","photo":"./data/images/photos/4/210868.png","club":{"name":"Cádiz C.F.","logo":"./data/images/clubs/CadizC.F..png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseMari0.json
// module id = 2175
// module chunks = 0